import React, { Component } from 'react'
import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import { appGlobal } from '../api/appGlobal';
import { mtUpdatePerson } from "../api/mtUpdatePerson";
import { getUUID } from "../api/getUUID";
import Steps from "./Steps";
import incode from './incode';
import "./styles.css";

async function getConfirmar(navigate, rutaContinue) {

    const objModelIncode = {
        interviewId: localStorage.getItem("interviewIdLic"),
        tokenIncode: localStorage.getItem("tokenIncodeLic"),
    };

    const responseModel = await getUUID(objModelIncode);

    const objPerson = {
        id: localStorage.getItem('idPerson'),
        interviewIdLic: localStorage.getItem("interviewIdLic"),
        tokenIncodeLic: localStorage.getItem("tokenIncodeLic"),
        edoEmisor: localStorage.getItem("emisor"),
        edoEmisorISO: localStorage.getItem("emisorISO"),
        tipoLic: localStorage.getItem("tipoLicencia"),
        numeroLic: localStorage.getItem("numeroLicencia"),
        vigencia: localStorage.getItem("vigencia"),
        datosLicenciaCompleto: true,
        similarity: localStorage.getItem("similarity"),
        uuidLic: responseModel.uuid
    }

    const response = await mtUpdatePerson(objPerson);

    if (response.status == 200) {
        localStorage.removeItem("emisor");
        localStorage.removeItem("emisorISO");
        localStorage.removeItem("tipoLicencia");
        localStorage.removeItem("numeroLicencia");
        navigate(rutaContinue);
    }

}

function FaceAutenticar({ rutaContinue, navigate, showError, showExitos }) {

    const containerRef = useRef();
    useEffect(() => {
        incode.renderLogin(containerRef.current, {
            onSuccess: r => {
                getConfirmar(navigate, rutaContinue);
            },
            onError: showError,
        });
    }, [showError, showExitos]);

    return <div ref={containerRef}></div>;
}

export default function FaceLogin() {

    const navigate = useNavigate();
    const location = useLocation();

    const [session, setSession] = useState();
    const [step, setStep] = useState(1);
    const [error, setError] = useState(false);
    const [Token, setToken] = useState('');

    const rutaContinue = location.state.rutaContinue;
    const typeCredential = location.state.typeCredential;

    const flowId = appGlobal.configurationId;

    useEffect(() => {

        async function createSession() {
            const { token } = await incode.createSession("ALL", null, {
                configurationId: flowId,
            });
            setToken(token);
        }
        createSession();

    }, []);


    function goNext() {
        setStep(step + 1);
    }

    function showError() {
        setError(true);
    }

    function showExitos() {
        incode.getFinishStatus(flowId, { Token });
    }

    if (!Token) return "loading";
    if (error) return "Error!";
    return (
        <>
            <link
                rel="stylesheet"
                href="https://sdk-js.s3.amazonaws.com/sdk/styles-1.6.4.css"
            />
            <FaceAutenticar rutaContinue={rutaContinue} navigate={navigate} showError={showError} showExitos={showExitos} />
        </>
    );
}
